import { Component, Event, EventEmitter, h, Prop } from '@stencil/core'

import { IBanner } from '../../app'

const exclamations = [
  'Nice!',
  'Yay!',
  'Congrats!',
  'Sweet!',
  'Hooray!',
  'Rock On!',
  'Awesome!',
  'Woohoo!',
  'Incredible!',
]

let exclamationIndex = 0

function getExclamation() {
  return exclamations[exclamationIndex++ % exclamations.length]
}

function getSubmitLabel(banner: IBanner) {
  return banner.messageType === 'signed_up_with_your_invite_code'
    ? 'Claim Your Referral Rewards'
    : 'Collect Your Points'
}

@Component({
  tag: 'gamification-success-modal',
})
export class Modal {
  @Event() closed: EventEmitter
  @Prop() banner: IBanner

  exclamation: string

  componentWillLoad() {
    this.exclamation = getExclamation()
  }

  render() {
    return (
      <ui-dialog
        content={({ dialog }) => (
          <div
            class={`flex flex-col spacing-y-2 items-center text-center py-6 px-8 justify-center rounded-md bg-info-warn text-black text-md`}
            style={{ maxWidth: '410px' }}
          >
            <ui-icon icon='star-shine' class='flex -mt-3px mr-1' style={{ fontSize: '60px' }} />
            <em class='text-4xl not-italic font-extrabold'>{this.exclamation}</em>
            <h2 class='text-xl font-extrabold'>{this.banner.message[0]}</h2>
            {this.banner.message.length > 1 && (
              <span class='text-lg tracking-tight'>{this.banner.message.slice(1).join(' ')}</span>
            )}
            <button onClick={() => dialog.close()} class='py-1 px-3 mt-3 text-base font-bold rounded-md border-2'>
              {getSubmitLabel(this.banner)}
            </button>
          </div>
        )}
      />
    )
  }
}
